import React, { useState, useEffect } from "react";
import { DataGrid, GridActionsCellItem, GridDeleteIcon, GridToolbar } from "@mui/x-data-grid";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import SuccessAlert from "../success-alert/SuccessAlert";
import ErrorAlert from "../error-alert/ErrorAlert";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import EditIcon from "@mui/icons-material/Edit";
import EditPromo from "../editors/EditPromo";
import { Switch } from "@mui/material";

export default function PromosDataTable({ data, endpoint, setRefresh, refresh, user, permNumber }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [confirmed2, setConfirmed2] = useState(false);
  const [clickedEntryId, setClickedEntryId] = useState();
  const [selected, setSelected] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState(false);
  const [item, setItem] = useState({});
  const [checks, setChecks] = useState([]);

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "image",
      headerName: "Image",
      width: 100,
      renderCell: (params) => (
        <img
          src={params.value}
          style={{
            height: "74%",
            aspectRatio: 1,
            borderRadius: 25,
            marginTop: "6%",
            objectFit: "cover",
          }}
        />
      ),
    },
    { field: "title", headerName: "Title", width: 170 },
    {
      field: "startsAt",
      headerName: "Starts At",
      width: 150,
    },
    {
      field: "endsAt",
      headerName: "Ends At",
      width: 150,
    },
    {
      field: "lang",
      headerName: "Language",
      width: 110,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      cellClassName: "actions",
      width: 130,
      getActions: ({ id }) => {
        return [
          <Switch
            disabled={!user.perms[permNumber].edit}
            size="small"
            checked={checks.find((check) => check.id === id)?.public || false}
            onChange={() => handleSwitchToggle(id)}
          />,
          <>
            {user.perms[permNumber].edit && (
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Delete"
                onClick={() => setItem({ id })}
              />
            )}
          </>,
          <>
            {user.perms[permNumber].delete && (
              <GridActionsCellItem
                icon={<GridDeleteIcon />}
                label="Delete"
                onClick={handleDeleteClick(id)}
              />
            )}
          </>,
        ];
      },
    },
  ];

  const handleSwitchToggle = async (id) => {
    const itemIndex = checks.findIndex((check) => check.id === id);
    if (itemIndex > -1) {
      const updatedChecks = [...checks];
      const newActiveStatus = !updatedChecks[itemIndex].public;
      updatedChecks[itemIndex].public = newActiveStatus;
      setChecks(updatedChecks);

      try {
        // Update the active status on the server
        await fetch(`${API}/${endpoint}/${id}`, {
          method: "PUT",
          headers: {
            ...headers,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: { public: newActiveStatus } }),
        });
      } catch (error) {
        console.error("Error updating active status:", error);
        setFail(true);
      }
    }
  };

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    setClickedEntryId(id);
  };

  useEffect(() => {
    async function deleteEntry() {
      if (confirmed == true) {
        fetch(`${API}/${endpoint}/${clickedEntryId}`, {
          headers,
          method: "DELETE",
        }).then(async (res) => {
          if (res.ok) {
            setSuccess(true);
            setRows(rows.filter((row) => row.id !== clickedEntryId));
            setConfirmed(false);
          } else {
            setFail(true);
            setConfirmed(false);
          }
        });
      }
    }

    deleteEntry();
  }, [confirmed]);

  useEffect(() => {
    let docs = [];
    let checksDocs = [];
    data?.forEach((item, index) => {
      docs = [
        ...docs,
        {
          id: item.id,
          title: item.attributes.title,
          startsAt: new Date(item.attributes.startsAt).toLocaleString("tr-TR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
          endsAt: new Date(item.attributes.endsAt).toLocaleString("tr-TR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }),
          image: item.attributes?.bg ? `${SERVER_DOMAIN + item.attributes?.bg}` : "",
          lang: item.attributes.lang,
        },
      ];

      checksDocs.push({
        id: item.id,
        public: item.attributes.public,
      });
    });
    setRows(docs);
    setChecks(checksDocs);
  }, [data]);

  const deleteSelectedItems = async () => {
    setOpen2(true);
  };

  useEffect(() => {
    async function deleteSelected() {
      if (confirmed2 == true) {
        setDeleteSelected(false);
        try {
          await Promise.all(
            selected.map(async (item) => {
              await fetch(`${API}/${endpoint}/${item}`, {
                headers,
                method: "DELETE",
              });
            })
          );

          const updatedRows = rows.filter((row) => !selected.includes(row.id));
          setRows(updatedRows);
          setSelected([]);
          setSuccess(true);
        } catch (error) {
          console.error("Error deleting items:", error);
        }
      }
    }

    deleteSelected();
  }, [confirmed2]);

  return (
    <div style={{ width: "100%" }}>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
      <DataGrid
        sx={{ minHeight: 580 }}
        disableColumnSorting
        disableAutosize
        disableColumnFilter
        onRowSelectionModelChange={(v) => {
          setSelected(v);
          if (v.length > 0) {
            setDeleteSelected(true);
          } else {
            setDeleteSelected(false);
          }
        }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30]}
        checkboxSelection
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: { disableToolbarButton: true },
            printOptions: { disableToolbarButton: true },
          },
        }}
      />
      {deleteSelected && user.perms[permNumber].delete && (
        <div onClick={deleteSelectedItems} className="deleteBTN">
          Delete Selected Items
        </div>
      )}
      <ConfirmationModal
        message={"Are you sure you want to delete this item?"}
        open={open}
        setOpen={setOpen}
        setConfirmed={(v) => setConfirmed(v)}
      />
      <ConfirmationModal
        message={"Are you sure you want to delete the selected items?"}
        open={open2}
        setOpen={setOpen2}
        setConfirmed={(v) => setConfirmed2(v)}
      />

      <EditPromo
        endpoint={endpoint}
        itemToEdit={item}
        setItemToEdit={setItem}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
}
